'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require('react-bootstrap');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactIntl = require('react-intl');

var _axwayReactIntl = require('axway-react-intl');

var _axwayReactIntl2 = _interopRequireDefault(_axwayReactIntl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PopOver = function (_React$Component) {
	_inherits(PopOver, _React$Component);

	function PopOver(props) {
		_classCallCheck(this, PopOver);

		var _this = _possibleConstructorReturn(this, (PopOver.__proto__ || Object.getPrototypeOf(PopOver)).call(this, props));

		_axwayReactIntl2.default.init(_this);
		return _this;
	}

	_createClass(PopOver, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    children = _props.children,
			    docLink = _props.docLink,
			    className = _props.className,
			    target = _props.target,
			    rel = _props.rel,
			    props = _objectWithoutProperties(_props, ['children', 'docLink', 'className', 'target', 'rel']);

			delete props.intl;

			return _react2.default.createElement(
				_reactBootstrap.Popover,
				_extends({}, props, { className: (0, _classnames2.default)('icon-info-popover', className) }),
				children && _react2.default.createElement(
					'section',
					{ className: 'icon-info-popover-content' },
					children
				),
				docLink && _react2.default.createElement(
					'section',
					{ className: 'icon-info-popover-doc-link' },
					_react2.default.createElement(
						'a',
						{ href: docLink, target: target, rel: rel },
						_react2.default.createElement('span', { className: 'gg icon-GG-lifebuoy icon-info-popover-doc-link-icon' }),
						_react2.default.createElement(
							'span',
							null,
							this.intl.formatMsg('View documentation')
						)
					)
				)
			);
		}
	}]);

	return PopOver;
}(_react2.default.Component);

PopOver.propTypes = _extends({}, _reactBootstrap.Popover.propTypes, {
	title: _propTypes2.default.node,
	docLink: _propTypes2.default.string,
	target: _propTypes2.default.string,
	rel: _propTypes2.default.string

});

PopOver.defaultProps = _extends({}, _reactBootstrap.Popover.defaultProps, {
	style: {},
	target: '_blank',
	rel: 'noopener noreferrer'
});

var _default = (0, _reactIntl.injectIntl)(PopOver);

exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(PopOver, 'PopOver', 'src/components/PopOver.jsx');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/PopOver.jsx');
}();

;